import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'SHOT BAND',
    loading: 'Loading SHOT BAND...',

    heroWelcome: 'Welcome to',
    heroMemberBadge: 'SHOT BAND member',
    heroDaysLeftOne: '{{count}} day left',
    heroDaysLeftFew: '{{count}} days left',
    heroDaysLeftMany: '{{count}} days left',
    heroDaysLeftZero: 'Membership ends today',
    heroRenewButton: 'Renew',
    heroOfferTitlePrefix: 'The',
    heroOfferTitleSuffix: 'top-up turns the club on — here or in any top-up.',
    heroOfferBody: 'Cashback up to 4% — it grows with your level — daily quests and a shot at the knife raffle.',
    heroOfferFinePrint: 'The whole amount lands on your game balance. Spend it on cases, contracts, games and upgrades however you like.',
    heroJoinButton: 'Join for',
    heroHowItWorks: 'How it works',

    rulesTitle: 'How SHOT BAND works',
    rule1Prefix: 'Top up ',
    rule1Suffix: " in one payment — you're in SHOT BAND for 28 days. The coins land on your balance as usual.",
    rule1Title: 'Joining SHOT BAND',
    rule2Title: 'Cashback up to 4%',
    rule2: 'Every coin game pays cashback back in sparks. The rate grows with your level — 1% at level 10, 4% at level 100. Claim it every 7 days.',
    rule3Title: 'Cases for sparks',
    rule3Prefix: 'Sparks ',
    rule3Suffix: ' open SHOT BAND cases — skins all the way up to knives.',
    rule4Title: 'Quests and streak',
    rule4Prefix: 'Daily quests earn ',
    rule4Mid: '. Keep a 7-day streak — get +10 ',
    rule4Suffix: ' as a bonus.',
    rule5Title: 'Weekly knife raffle',
    rule5Prefix: 'Every week we raffle a knife. Invest your ',
    rule5Suffix: ' — more tickets, higher chance.',
    rule6Title: 'Daily race',
    rule6: 'Wager the most coins before midnight (MSK) and take the day’s skin. Every day, a new prize.',
    rule7Title: 'Free cases for turnover',
    rule7: 'Your daily turnover opens shelf cases for free — the more you play, the richer the free case. Up to every case, every day.',

    ticketSheetTitleJoin: 'Join SHOT BAND',
    ticketSheetTitleRenew: 'Renew SHOT BAND',
    ticketSheetTopupNotePrefix: 'Your balance is credited with',
    ticketSheetTopupNoteSuffix: 'right away — the club comes as a gift.',
    ticketSheetRenewDisclaimer: 'Renewal adds 28 days to your current membership term.',
    ticketSheetRenewTooEarly: 'Renewal opens a day before your membership ends — come back closer to that date.',
    ticketSheetBuyButton: 'Pay',
    ticketSheetLoadingProviders: 'Loading payment methods...',
    ticketSheetNoProviders: 'No payment methods available right now.',
    ticketSheetErrorTitle: 'Could not create the invoice',
    ticketSheetErrorHint: 'Try again or pick another method',
    ticketSheetLoadErrorGeneric: 'Failed to load payment methods.',
    ticketSheetPriceUnavailable: 'Price unavailable for this payment method — try another one.',
    ticketSheetCardConfirmTitle: 'Confirm payment',
    ticketSheetCardConfirmMessage: 'Charge {{amount}} from {{card}} to join SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pay',
    ticketSheetCardPending: 'Click is still confirming the payment — your membership will switch on automatically.',
    ticketSheetCardErrorTitle: 'Payment did not go through',
    ticketSheetCardErrorHint: 'Try again; if the money left your card, contact support',

    cashbackBalanceLabel: 'Club balance',
    cashbackCoinsLabel: 'Sparks',
    cashbackTicketsLabel: 'Tickets',
    cashbackNextPayoutLabel: 'Next payout:',
    mechanicNameCase: 'Cases',
    mechanicNameBattle: 'Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roulette',
    mechanicNameUpgrade: 'Upgrades',
    mechanicNameContract: 'Contracts',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback from lvl {{level}}',
    cashbackSpendButton: 'Spend',
    cashbackInvestButton: 'Invest',
    cashbackFrozenNote: 'Your membership has ended — the sparks and tickets stay yours. You can still claim sparks; spending them and entering the raffle need the club back on.',
    cashbackUnlockButton: 'Come back',
    cashbackClaimReadyLabel: 'Cashback ready:',
    cashbackClaimButton: 'Claim',
    cashbackTimerLabel: 'in',

    streakDayLabel: 'Day {{day}} of 7',
    streakHint: '{{days}} days in a row — bonus',

    freeCasesTitle: 'Free case',
    freeCasesTurnoverLabel: 'Turnover today',
    freeCasesNextHintPrefix: 'Wager',
    freeCasesNextHintSuffix: "more and you'll open it for free",
    freeCasesReadyHint: 'Free to open — go!',
    freeCasesAllClaimed: 'All free opens for today are spent — new ones after the reset',
    freeCasesTimerBurnOpen: 'The free open burns at the reset',
    freeCasesTimerBurnProgress: 'Turnover progress burns at the reset',
    freeCasesTimerPlain: 'Day resets in',
    freeCasesTimerNew: 'New free opens in',
    freeCasesOpenFreeButton: 'Open',
    freeCasesRulesTitle: 'Free case rules',
    freeCasesRulesWagerTitle: 'Play for coins',
    freeCasesRulesWagerBody: 'Every coin game counts into your daily turnover — cases, battles, upgrades, contracts, Rush Mid, roulette.',
    freeCasesRulesOpenTitle: 'Reach the threshold — open for free',
    freeCasesRulesOpenBody: 'Each case has its own turnover threshold. Reached it — the club pays for the open. One free open per case per day.',
    freeCasesRulesResetTitle: 'Everything burns at midnight',
    freeCasesRulesResetBody: 'At midnight (MSK) the day resets: turnover progress and unclaimed free opens burn. Next day — from zero.',

    questsTitle: 'Daily quests',
    questsResetLabel: 'New quests in',
    questClaimButton: 'Claim',
    questsLockedJoinButton: 'Join',
    questGenericTitle: 'Daily quest',
    questCompletedToastOverline: 'Quest complete!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Open 3 cases worth',
    quest_open_3_cases_2500_suffix: 'or more',
    quest_open_3_cases_2500_unit: 'cases',
    quest_rush_3_matches_prefix: 'Play 3 Rush Mid matches',
    quest_rush_3_matches_unit: 'matches',
    quest_open_band_case_prefix: 'Open a SHOT BAND case',
    quest_open_band_case_unit: 'case',
    quest_wager_25k_prefix: 'Wager',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Play 2 case battles with an entry of',
    quest_battles_2_5k_suffix: 'or more',
    quest_battles_2_5k_unit: 'battles',
    quest_upgrades_3_2500_prefix: 'Make 3 upgrades worth',
    quest_upgrades_3_2500_suffix: 'or more',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Complete a contract worth',
    quest_contract_10k_suffix: 'or more',
    quest_contract_10k_unit: 'contract',
    quest_win_battle_prefix: 'Win a case battle',
    quest_win_battle_unit: 'battle',
    quest_win_upgrade_prefix: 'Win an upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Open a case worth',
    quest_open_case_12500_suffix: 'or more',
    quest_open_case_12500_unit: 'case',
    quest_open_5_cases_1000_prefix: 'Open 5 cases worth',
    quest_open_5_cases_1000_suffix: 'or more',
    quest_open_5_cases_1000_unit: 'cases',
    quest_roulette_play_prefix: 'Play a roulette round',
    quest_roulette_play_unit: 'round',
    quest_contracts_25k_sum_prefix: 'Complete contracts worth',
    quest_contracts_25k_sum_suffix: 'in total',
    quest_upgrades_15k_sum_prefix: 'Make upgrades worth',
    quest_upgrades_15k_sum_suffix: 'in total',
    quest_rush_5_matches_prefix: 'Play 5 Rush Mid matches',
    quest_rush_5_matches_unit: 'matches',
    quest_wager_50k_prefix: 'Wager',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Wager',
    quest_wager_10k_battles_suffix: 'in case battles',
    quest_wager_10k_rush_prefix: 'Wager',
    quest_wager_10k_rush_suffix: 'in Rush Mid',
    quest_wager_10k_roulette_prefix: 'Wager',
    quest_wager_10k_roulette_suffix: 'in roulette',
    quest_wager_100k_prefix: 'Wager',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Win a Rush Mid match',
    quest_rush_mid_win_unit: 'win',
    quest_big_drop_25k_prefix: 'Drop an item worth over',
    quest_big_drop_25k_suffix: 'from a case',
    quest_big_drop_25k_unit: 'item',
    quest_risky_upgrade_35_prefix: 'Win an upgrade with odds of 35% or lower',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Drop a Covert item from a case',
    quest_covert_drop_unit: 'item',

    raceTitle: 'Daily race',
    raceEmpty: 'No race today — check back later',
    rulesLinkLabel: 'Rules',
    raceRulesTitle: 'Daily race rules',
    raceRulesPlayTitle: 'How to win',
    raceRulesPlayBody: 'Play anything on SHOT — cases, upgrades, contracts, battles, Rush Mid, roulette. The coins you spend on games count: the biggest daily turnover wins.',
    raceRulesPrizeTitle: 'The prize',
    raceRulesPrizeBody: 'A new skin every day. At midnight (MSK) it goes to the #1 player and lands straight in their inventory.',
    raceRulesMembersTitle: 'Members only',
    raceRulesMembersBody: 'The race is for SHOT BAND members. Your play counts automatically — nothing to activate.',
    raffleRulesTitle: 'Weekly raffle rules',
    raffleRulesTicketsTitle: 'Earn tickets',
    raffleRulesTicketsBodyPrefix: 'Complete daily quests to earn raffle tickets',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'Invest to raise your chance',
    raffleRulesChanceBody: 'Invest tickets into the round — the more you invest, the higher your chance. Invested tickets are not returned, adding more is always allowed.',
    raffleRulesFinalTitle: 'The final',
    raffleRulesFinalBody: 'The round runs for a week. The winner is drawn at random and the skin lands straight in their inventory.',
    racePrizeLabel: "Today's prize",
    raceYourPlace: 'Your place',
    raceParticipantsLabel: 'Playing',
    raceNotWagered: 'Play anything today to join the race',

    raffleTitle: 'Weekly raffle',
    raffleEmpty: 'No raffle running this week',
    raffleMyInvestedLabel: 'Invested',
    raffleParticipantsLabel: 'Playing',
    raffleParticipantOne: 'participant',
    raffleParticipantFew: 'participants',
    raffleParticipantMany: 'participants',
    raffleInvestButton: 'Invest',
    raffleGoToQuestsButton: 'Go to quests',
    raffleEndedButton: 'Round ended',
    raffleWinnersLink: 'Winners',

    investSheetTitle: 'Invest in the raffle',
    investSheetLockedBody: 'Join SHOT BAND to invest in the weekly raffle.',
    investSheetJoinButton: 'Join',
    investSheetEndedBody: 'This round has ended — wait for the next one.',
    investSheetNoBalanceBody: 'Nothing to invest yet — complete daily quests to earn some.',
    investSheetDecrease: 'Decrease',
    investSheetIncrease: 'Increase',
    investSheetBalanceHint: '{{balance}} available',
    investSheetDisclaimer: 'Invested amounts are not returned — you can always add more.',
    investSheetErrorGeneric: 'Failed to invest. Try again.',
    investSheetSubmitButton: 'Invest',
  },
  ru: {
    title: 'SHOT BAND',
    loading: 'Загрузка SHOT BAND...',

    heroWelcome: 'Добро пожаловать в',
    heroMemberBadge: 'Ты в SHOT BAND',
    heroDaysLeftOne: 'Остался {{count}} день',
    heroDaysLeftFew: 'Осталось {{count}} дня',
    heroDaysLeftMany: 'Осталось {{count}} дней',
    heroDaysLeftZero: 'Членство заканчивается сегодня',
    heroRenewButton: 'Продлить',
    heroOfferTitlePrefix: 'Пополнение на',
    heroOfferTitleSuffix: 'включает клуб — здесь или в обычном пополнении.',
    heroOfferBody: 'Кешбэк до 4% — растёт с уровнем, ежедневные задания и шанс выиграть нож в розыгрыше.',
    heroOfferFinePrint: 'Вся сумма зачислится на твой игровой баланс. Ты сможешь тратить её на кейсы, контракты, игры и апгрейды как захочешь.',
    heroJoinButton: 'Вступить за',
    heroHowItWorks: 'Как это работает',

    rulesTitle: 'Как работает SHOT BAND',
    rule1Prefix: 'Закинь ',
    rule1Suffix: ' одним платежом — ты в SHOT BAND на 28 дней. Монеты придут на твой баланс, как обычно.',
    rule1Title: 'Вход в SHOT BAND',
    rule2Title: 'Кешбэк до 4%',
    rule2: 'Каждая игра за монеты возвращает кешбэк искрами. Процент растёт с уровнем — 1% на 10-м, 4% на 100-м. Забирай каждые 7 дней.',
    rule3Title: 'Кейсы за искры',
    rule3Prefix: 'Искры ',
    rule3Suffix: ' открывают кейсы SHOT BAND — внутри скины вплоть до ножей.',
    rule4Title: 'Задания и стрик',
    rule4Prefix: 'Ежедневные задания приносят ',
    rule4Mid: '. Держи стрик 7 дней — получишь +10 ',
    rule4Suffix: ' бонусом.',
    rule5Title: 'Розыгрыш ножа',
    rule5Prefix: 'Каждую неделю разыгрываем нож. Вкладывай ',
    rule5Suffix: ' — чем больше билетов, тем выше шанс.',
    rule6Title: 'Гонка дня',
    rule6: 'Наиграй за монеты больше всех до полуночи мск — и скин дня твой. Каждый день новый приз.',
    rule7Title: 'Кейсы бесплатно за оборот',
    rule7: 'Дневной оборот открывает кейсы полки бесплатно — чем больше играешь, тем дороже фри-кейс. Хоть все кейсы, хоть каждый день.',

    ticketSheetTitleJoin: 'Вступление в SHOT BAND',
    ticketSheetTitleRenew: 'Продление SHOT BAND',
    ticketSheetTopupNotePrefix: 'На баланс сразу зачислится',
    ticketSheetTopupNoteSuffix: '— клуб идёт подарком.',
    ticketSheetRenewDisclaimer: 'Продление добавится к текущему сроку членства — плюс 28 дней.',
    ticketSheetRenewTooEarly: 'Продление откроется за сутки до конца членства — загляни ближе к этому сроку.',
    ticketSheetBuyButton: 'Оплатить',
    ticketSheetLoadingProviders: 'Загружаем способы оплаты...',
    ticketSheetNoProviders: 'Сейчас нет доступных способов оплаты.',
    ticketSheetErrorTitle: 'Не получилось создать счёт',
    ticketSheetErrorHint: 'Попробуй ещё раз или выбери другой способ',
    ticketSheetLoadErrorGeneric: 'Не удалось загрузить способы оплаты.',
    ticketSheetPriceUnavailable: 'Цена недоступна для этого способа — выбери другой.',
    ticketSheetCardConfirmTitle: 'Подтверди оплату',
    ticketSheetCardConfirmMessage: 'Списать {{amount}} с карты {{card}} за пропуск в SHOT BAND?',
    ticketSheetCardConfirmOk: 'Оплатить',
    ticketSheetCardPending: 'Click ещё подтверждает платёж — членство включится автоматически.',
    ticketSheetCardErrorTitle: 'Оплата не прошла',
    ticketSheetCardErrorHint: 'Попробуй ещё раз; если деньги ушли с карты, напиши в поддержку',

    cashbackBalanceLabel: 'Баланс клуба',
    cashbackCoinsLabel: 'Искры',
    cashbackTicketsLabel: 'Билеты',
    cashbackNextPayoutLabel: 'Следующая выплата:',
    mechanicNameCase: 'Кейсы',
    mechanicNameBattle: 'Case Battles',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Рулетка',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Контракты',
    cashbackChipPrefix: 'кешбэк',
    cashbackChipLocked: 'кешбэк с {{level}} уровня',
    cashbackSpendButton: 'Потратить',
    cashbackInvestButton: 'Вложить',
    cashbackFrozenNote: 'Членство закончилось — искры и билеты остались твоими. Забрать искры можно и сейчас, а тратить их и вкладывать билеты — только в клубе.',
    cashbackUnlockButton: 'Вернуться',
    cashbackClaimReadyLabel: 'Кешбэк готов:',
    cashbackClaimButton: 'Забрать',
    cashbackTimerLabel: 'через',

    streakDayLabel: 'День {{day}} из 7',
    streakHint: '{{days}} дней подряд — бонус',

    freeCasesTitle: 'Бесплатный кейс',
    freeCasesTurnoverLabel: 'Оборот сегодня',
    freeCasesNextHintPrefix: 'Ещё',
    freeCasesNextHintSuffix: 'оборота — и откроешь его бесплатно',
    freeCasesReadyHint: 'Можно открыть бесплатно — забирай!',
    freeCasesAllClaimed: 'Всё бесплатное на сегодня открыто — новые после сброса',
    freeCasesTimerBurnOpen: 'Не откроешь до сброса — сгорит',
    freeCasesTimerBurnProgress: 'Прогресс оборота сгорит через',
    freeCasesTimerPlain: 'До сброса дня',
    freeCasesTimerNew: 'Новые бесплатные открытия через',
    freeCasesOpenFreeButton: 'Открыть',
    freeCasesRulesTitle: 'Правила бесплатного кейса',
    freeCasesRulesWagerTitle: 'Играй за монеты',
    freeCasesRulesWagerBody: 'Любая игра за монеты идёт в дневной оборот — кейсы, битвы, апгрейды, контракты, Rush Mid, рулетка.',
    freeCasesRulesOpenTitle: 'Взял порог — открываешь бесплатно',
    freeCasesRulesOpenBody: 'У каждого кейса свой порог оборота. Добрался — клуб платит за открытие. Одно бесплатное открытие на кейс в день.',
    freeCasesRulesResetTitle: 'В полночь всё сгорает',
    freeCasesRulesResetBody: 'В полночь по Москве день обнуляется: прогресс оборота и невзятые бесплатные открытия сгорают. Новый день — с нуля.',

    questsTitle: 'Задания дня',
    questsResetLabel: 'Новые задания через',
    questClaimButton: 'Забрать',
    questsLockedJoinButton: 'Вступить',
    questGenericTitle: 'Ежедневное задание',
    questCompletedToastOverline: 'Задание выполнено!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Открой 3 кейса от',
    quest_open_3_cases_2500_suffix: '',
    quest_open_3_cases_2500_unit: 'кейса',
    quest_rush_3_matches_prefix: 'Сыграй 3 матча в Rush Mid',
    quest_rush_3_matches_unit: 'матча',
    quest_open_band_case_prefix: 'Открой кейс SHOT BAND',
    quest_open_band_case_unit: 'кейс',
    quest_wager_25k_prefix: 'Прокрути',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Сыграй 2 баттла стоимостью от',
    quest_battles_2_5k_suffix: '',
    quest_battles_2_5k_unit: 'баттла',
    quest_upgrades_3_2500_prefix: 'Сделай 3 апгрейда от',
    quest_upgrades_3_2500_suffix: '',
    quest_upgrades_3_2500_unit: 'апгрейда',
    quest_contract_10k_prefix: 'Собери контракт от',
    quest_contract_10k_suffix: '',
    quest_contract_10k_unit: 'контракт',
    quest_win_battle_prefix: 'Выиграй баттл',
    quest_win_battle_unit: 'баттл',
    quest_win_upgrade_prefix: 'Выиграй апгрейд',
    quest_win_upgrade_unit: 'апгрейд',
    quest_open_case_12500_prefix: 'Открой кейс от',
    quest_open_case_12500_suffix: '',
    quest_open_case_12500_unit: 'кейс',
    quest_open_5_cases_1000_prefix: 'Открой 5 кейсов от',
    quest_open_5_cases_1000_suffix: '',
    quest_open_5_cases_1000_unit: 'кейсов',
    quest_roulette_play_prefix: 'Сыграй раунд рулетки',
    quest_roulette_play_unit: 'раунд',
    quest_contracts_25k_sum_prefix: 'Собери контрактов на',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Сделай апгрейдов на',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Сыграй 5 матчей Rush Mid',
    quest_rush_5_matches_unit: 'матчей',
    quest_wager_50k_prefix: 'Прокрути',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Прокрути',
    quest_wager_10k_battles_suffix: 'в баттлах',
    quest_wager_10k_rush_prefix: 'Прокрути',
    quest_wager_10k_rush_suffix: 'в Rush Mid',
    quest_wager_10k_roulette_prefix: 'Прокрути',
    quest_wager_10k_roulette_suffix: 'в рулетке',
    quest_wager_100k_prefix: 'Прокрути',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Победи в Rush Mid',
    quest_rush_mid_win_unit: 'победа',
    quest_big_drop_25k_prefix: 'Выбей предмет дороже',
    quest_big_drop_25k_suffix: 'из кейса',
    quest_big_drop_25k_unit: 'предмет',
    quest_risky_upgrade_35_prefix: 'Выиграй апгрейд с шансом до 35%',
    quest_risky_upgrade_35_unit: 'апгрейд',
    quest_covert_drop_prefix: 'Выбей предмет Covert из кейса',
    quest_covert_drop_unit: 'предмет',

    raceTitle: 'Гонка дня',
    raceEmpty: 'Сегодня гонки нет — загляни позже',
    rulesLinkLabel: 'Правила',
    raceRulesTitle: 'Правила гонки дня',
    raceRulesPlayTitle: 'Как победить',
    raceRulesPlayBody: 'Играй во что угодно в SHOT — кейсы, апгрейды, контракты, баттлы, Rush Mid, рулетку. Считаются потраченные на игры монеты: у кого оборот за день больше всех — тот и победил.',
    raceRulesPrizeTitle: 'Приз',
    raceRulesPrizeBody: 'Каждый день — новый скин. В полночь по Москве он уходит первому месту и сразу падает в инвентарь.',
    raceRulesMembersTitle: 'Только для клуба',
    raceRulesMembersBody: 'Гонка — для членов SHOT BAND. Игра засчитывается автоматически, ничего включать не надо.',
    raffleRulesTitle: 'Правила розыгрыша недели',
    raffleRulesTicketsTitle: 'Получай билеты',
    raffleRulesTicketsBodyPrefix: 'Выполняй задания дня — за них дают билеты',
    raffleRulesTicketsBodySuffix: 'розыгрыша.',
    raffleRulesChanceTitle: 'Вкладывай и повышай шанс',
    raffleRulesChanceBody: 'Вкладывай билеты в раунд — чем больше вложил, тем выше шанс. Вложенное не возвращается, докидывать можно всегда.',
    raffleRulesFinalTitle: 'Финал',
    raffleRulesFinalBody: 'Раунд идёт неделю. Победителя выбирает случайность, скин сразу падает в инвентарь.',
    racePrizeLabel: 'Приз дня',
    raceYourPlace: 'Твоё место',
    raceParticipantsLabel: 'Участвует',
    raceNotWagered: 'Сыграй сегодня в любую игру — и ты в гонке',

    raffleTitle: 'Розыгрыш недели',
    raffleEmpty: 'На этой неделе розыгрыша нет',
    raffleMyInvestedLabel: 'Вложено',
    raffleParticipantsLabel: 'Участвует',
    raffleParticipantOne: 'участник',
    raffleParticipantFew: 'участника',
    raffleParticipantMany: 'участников',
    raffleInvestButton: 'Вложить',
    raffleGoToQuestsButton: 'К заданиям',
    raffleEndedButton: 'Раунд завершён',
    raffleWinnersLink: 'Победители',

    investSheetTitle: 'Вклад в розыгрыш',
    investSheetLockedBody: 'Вступи в SHOT BAND, чтобы вкладывать в еженедельный розыгрыш.',
    investSheetJoinButton: 'Вступить',
    investSheetEndedBody: 'Этот раунд уже завершён — дождись следующего.',
    investSheetNoBalanceBody: 'Пока нечего вкладывать — выполняй задания дня, чтобы получить.',
    investSheetDecrease: 'Уменьшить',
    investSheetIncrease: 'Увеличить',
    investSheetBalanceHint: 'Доступно: {{balance}}',
    investSheetDisclaimer: 'Вложенное не возвращается — довложить можно в любой момент.',
    investSheetErrorGeneric: 'Не удалось вложить. Попробуй ещё раз.',
    investSheetSubmitButton: 'Вложить',
  },
  uz: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND yuklanmoqda...',

    heroWelcome: 'Xush kelibsan',
    heroMemberBadge: 'SHOT BAND aʼzosi',
    heroDaysLeftOne: '{{count}} kun qoldi',
    heroDaysLeftFew: '{{count}} kun qoldi',
    heroDaysLeftMany: '{{count}} kun qoldi',
    heroDaysLeftZero: 'Aʼzolik bugun tugaydi',
    heroRenewButton: 'Uzaytirish',
    heroOfferTitlePrefix: 'Hisob',
    heroOfferTitleSuffix: 'ga toʻldirish klubni yoqadi — shu yerda ham, oddiy toʻldirishda ham.',
    heroOfferBody: '4% gacha keshbek — daraja bilan oʻsadi, kunlik topshiriqlar va pichoq lotereyasi.',
    heroOfferFinePrint: 'Butun summa oʻyin balansingga tushadi. Uni keyslarga, kontraktlarga, oʻyinlarga va upgreydlarga xohlaganingcha sarflaysan.',
    heroJoinButton: 'Qoʻshilish —',
    heroHowItWorks: 'Bu qanday ishlaydi',

    rulesTitle: 'SHOT BAND qanday ishlaydi',
    rule1Prefix: 'Bir martalik ',
    rule1Suffix: " toʻlov bilan 28 kunga SHOT BANDʼga aʼzo boʻlasan. Tangalar odatdagidek balansingga tushadi.",
    rule1Title: 'Klubga kirish',
    rule2Title: '4% gacha keshbek',
    rule2: 'Tangaga har bir oʻyin uchqunlar bilan keshbek qaytaradi. Foiz daraja bilan oʻsadi — 10-darajada 1%, 100-darajada 4%. Har 7 kunda olib tur.',
    rule3Title: 'Uchqunga keyslar',
    rule3Prefix: 'Uchqunlar ',
    rule3Suffix: " SHOT BAND keyslarini ochadi — ichida pichoqlargacha skinlar.",
    rule4Title: 'Topshiriqlar va strik',
    rule4Prefix: 'Kunlik topshiriqlar ',
    rule4Mid: " beradi. 7 kunlik strikni saqla — bonus sifatida +10 ",
    rule4Suffix: '.',
    rule5Title: 'Pichoq lotereyasi',
    rule5Prefix: 'Har hafta pichoq oʻynaymiz. Oʻz ',
    rule5Suffix: 'laringni qoʻy — bilet koʻp boʻlsa, imkoniyat yuqori.',
    rule6Title: 'Kun poygasi',
    rule6: 'Yarim tungacha (MSK) tangaga eng koʻp oʻynagan kun skinini oladi. Har kuni yangi sovgʻa.',
    rule7Title: 'Aylanma uchun bepul keyslar',
    rule7: 'Kunlik aylanma keyslarni bepul ochadi — qancha koʻp oʻynasang, bepul keys shuncha qimmat. Har kuni, istalgan keysgacha.',

    ticketSheetTitleJoin: "SHOT BANDʼga qoʻshilish",
    ticketSheetTitleRenew: 'SHOT BAND aʼzoligini uzaytirish',
    ticketSheetTopupNotePrefix: 'Balansingga darhol',
    ticketSheetTopupNoteSuffix: 'tushadi — klub sovgʻa sifatida beriladi.',
    ticketSheetRenewDisclaimer: 'Uzaytirish joriy muddatga qoʻshiladi — plyus 28 kun.',
    ticketSheetRenewTooEarly: 'Uzaytirish aʼzolik tugashiga bir kun qolganda ochiladi — shu muddatga yaqinroq kel.',
    ticketSheetBuyButton: 'Toʻlash',
    ticketSheetLoadingProviders: 'Toʻlov usullari yuklanmoqda...',
    ticketSheetNoProviders: 'Hozircha toʻlov usullari mavjud emas.',
    ticketSheetErrorTitle: "Hisob yaratilmadi",
    ticketSheetErrorHint: 'Qayta urinib koʻr yoki boshqa usulni tanla',
    ticketSheetLoadErrorGeneric: 'Toʻlov usullarini yuklab boʻlmadi.',
    ticketSheetPriceUnavailable: 'Bu toʻlov usuli uchun narx mavjud emas — boshqasini tanla.',
    ticketSheetCardConfirmTitle: 'Toʻlovni tasdiqla',
    ticketSheetCardConfirmMessage: "SHOT BANDʼga qoʻshilish uchun {{card}} kartadan {{amount}} yechilsinmi?",
    ticketSheetCardConfirmOk: 'Toʻlash',
    ticketSheetCardPending: 'Click toʻlovni hali tasdiqlamoqda — aʼzolik avtomatik yoqiladi.',
    ticketSheetCardErrorTitle: 'Toʻlov oʻtmadi',
    ticketSheetCardErrorHint: 'Qayta urinib koʻr; pul kartadan yechilgan boʻlsa, qoʻllab-quvvatlashga yoz',

    cashbackBalanceLabel: 'Klub balansi',
    cashbackCoinsLabel: 'Uchqunlar',
    cashbackTicketsLabel: 'Chiptalar',
    cashbackNextPayoutLabel: 'Keyingi toʻlov:',
    mechanicNameCase: 'Keyslar',
    mechanicNameBattle: 'Battlar',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Ruletka',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Kontraktlar',
    cashbackChipPrefix: 'keshbek',
    cashbackChipLocked: 'keshbek {{level}}-darajadan',
    cashbackSpendButton: 'Sarflash',
    cashbackInvestButton: 'Qoʻyish',
    cashbackFrozenNote: 'Aʼzoliging tugadi — uchqunlaring ham, chiptalaring ham sendaligicha qoldi. Uchqunlarni hozir ham yigʻib olsang boʻladi, sarflash va chipta qoʻyish esa faqat klub ichida.',
    cashbackUnlockButton: 'Qaytish',
    cashbackClaimReadyLabel: 'Keshbek tayyor:',
    cashbackClaimButton: 'Olish',
    cashbackTimerLabel: 'ichida',

    streakDayLabel: '{{day}}-kun / 7 kun',
    streakHint: '{{days}} kun ketma-ket — bonus',

    freeCasesTitle: 'Bepul keys',
    freeCasesTurnoverLabel: 'Bugungi aylanma',
    freeCasesNextHintPrefix: 'Yana',
    freeCasesNextHintSuffix: "aylanma — va uni bepul ochasan",
    freeCasesReadyHint: 'Bepul ochish mumkin — ol!',
    freeCasesAllClaimed: "Bugungi barcha bepul ochishlar ishlatildi — yangilari yangilanishdan keyin",
    freeCasesTimerBurnOpen: "Ochmasang — yonib ketadi",
    freeCasesTimerBurnProgress: "Aylanma progressi yonib ketadi",
    freeCasesTimerPlain: 'Kun yangilanishigacha',
    freeCasesTimerNew: 'Yangi bepul ochishlar',
    freeCasesOpenFreeButton: 'Ochish',
    freeCasesRulesTitle: 'Bepul keys qoidalari',
    freeCasesRulesWagerTitle: 'Tangaga oʻyna',
    freeCasesRulesWagerBody: 'Tangaga har qanday oʻyin kunlik aylanmaga hisoblanadi — keyslar, janglar, upgreydlar, kontraktlar, Rush Mid, ruletka.',
    freeCasesRulesOpenTitle: 'Chegaraga yetding — bepul ochasan',
    freeCasesRulesOpenBody: 'Har bir keysning oʻz aylanma chegarasi bor. Yetib olding — ochish klub hisobidan. Har keysga kuniga bitta bepul ochish.',
    freeCasesRulesResetTitle: 'Yarim tunda hammasi yonadi',
    freeCasesRulesResetBody: "Moskva vaqti bilan yarim tunda kun yangilanadi: aylanma progressi va olinmagan bepul ochishlar yonib ketadi. Yangi kun — noldan.",

    questsTitle: 'Kunlik topshiriqlar',
    questsResetLabel: "Yangi topshiriqlargacha",
    questClaimButton: 'Olish',
    questsLockedJoinButton: 'Qoʻshilish',
    questGenericTitle: 'Kunlik topshiriq',
    questCompletedToastOverline: 'Topshiriq bajarildi!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '',
    quest_open_3_cases_2500_suffix: "dan qimmat 3 ta keys och",
    quest_open_3_cases_2500_unit: 'keys',
    quest_rush_3_matches_prefix: "Rush Midʼda 3 ta matchda oʻyna",
    quest_rush_3_matches_unit: 'match',
    quest_open_band_case_prefix: 'SHOT BAND keysini och',
    quest_open_band_case_unit: 'keys',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: ' aylantir',
    quest_battles_2_5k_prefix: 'Kirish toʻlovi',
    quest_battles_2_5k_suffix: 'dan yuqori boʻlgan 2 ta jangda oʻyna',
    quest_battles_2_5k_unit: 'jang',
    quest_upgrades_3_2500_prefix: '',
    quest_upgrades_3_2500_suffix: 'dan qimmat 3 ta apgreyd qil',
    quest_upgrades_3_2500_unit: 'apgreyd',
    quest_contract_10k_prefix: '',
    quest_contract_10k_suffix: 'dan qimmat kontrakt tuz',
    quest_contract_10k_unit: 'kontrakt',
    quest_win_battle_prefix: 'Jangda gʻalaba qozon',
    quest_win_battle_unit: 'jang',
    quest_win_upgrade_prefix: 'Apgreydda yutib chiq',
    quest_win_upgrade_unit: 'apgreyd',
    quest_open_case_12500_prefix: '',
    quest_open_case_12500_suffix: 'dan qimmat keys och',
    quest_open_case_12500_unit: 'keys',
    quest_open_5_cases_1000_prefix: '',
    quest_open_5_cases_1000_suffix: 'dan qimmat 5 ta keys och',
    quest_open_5_cases_1000_unit: 'keys',
    quest_roulette_play_prefix: 'Ruletka turida oʻyna',
    quest_roulette_play_unit: 'tur',
    quest_contracts_25k_sum_prefix: 'Jami',
    quest_contracts_25k_sum_suffix: 'lik kontraktlar tuz',
    quest_upgrades_15k_sum_prefix: 'Jami',
    quest_upgrades_15k_sum_suffix: 'lik apgreydlar qil',
    quest_rush_5_matches_prefix: "Rush Midʼda 5 ta matchda oʻyna",
    quest_rush_5_matches_unit: 'match',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: ' aylantir',
    quest_wager_10k_battles_prefix: 'Janglarda',
    quest_wager_10k_battles_suffix: ' aylantir',
    quest_wager_10k_rush_prefix: "Rush Midʼda",
    quest_wager_10k_rush_suffix: ' aylantir',
    quest_wager_10k_roulette_prefix: 'Ruletkada',
    quest_wager_10k_roulette_suffix: ' aylantir',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: ' aylantir',
    quest_rush_mid_win_prefix: "Rush Midʼda gʻalaba qozon",
    quest_rush_mid_win_unit: 'gʻalaba',
    quest_big_drop_25k_prefix: 'Keysdan',
    quest_big_drop_25k_suffix: 'dan qimmat buyum tushir',
    quest_big_drop_25k_unit: 'buyum',
    quest_risky_upgrade_35_prefix: 'Ehtimolligi 35% gacha boʻlgan apgreydda yutib chiq',
    quest_risky_upgrade_35_unit: 'apgreyd',
    quest_covert_drop_prefix: 'Keysdan Covert buyum tushir',
    quest_covert_drop_unit: 'buyum',

    raceTitle: 'Kunlik poyga',
    raceEmpty: 'Bugun poyga yoʻq — keyinroq kir',
    rulesLinkLabel: 'Qoidalar',
    raceRulesTitle: 'Kunlik poyga qoidalari',
    raceRulesPlayTitle: 'Qanday gʻalaba qozonish',
    raceRulesPlayBody: "SHOTʼda istalgan oʻyinni oʻyna — keyslar, apgreydlar, kontraktlar, janglar, Rush Mid, ruletka. Oʻyinlarga sarflangan tangalar hisoblanadi: kunlik aylanmasi eng katta boʻlgan yutadi.",
    raceRulesPrizeTitle: 'Sovgʻa',
    raceRulesPrizeBody: 'Har kuni yangi skin. Yarim tunda (MSK) u birinchi oʻringa beriladi va darhol inventarga tushadi.',
    raceRulesMembersTitle: "Faqat klub uchun",
    raceRulesMembersBody: 'Poyga — SHOT BAND aʼzolari uchun. Oʻyin avtomatik hisoblanadi, hech narsani yoqish shart emas.',
    raffleRulesTitle: 'Haftalik lotereya qoidalari',
    raffleRulesTicketsTitle: 'Chiptalarni yig',
    raffleRulesTicketsBodyPrefix: 'Kunlik topshiriqlarni bajar — ular uchun lotereya chiptalari',
    raffleRulesTicketsBodySuffix: 'beriladi.',
    raffleRulesChanceTitle: 'Qoʻy va imkoniyatni oshir',
    raffleRulesChanceBody: 'Chiptalarni turga qoʻy — qancha koʻp qoʻysang, imkoniyat shuncha yuqori. Qoʻyilganlar qaytarilmaydi, yana qoʻshish mumkin.',
    raffleRulesFinalTitle: 'Final',
    raffleRulesFinalBody: 'Tur bir hafta davom etadi. Gʻolibni tasodif tanlaydi, skin darhol inventarga tushadi.',
    racePrizeLabel: 'Kun sovgʻasi',
    raceYourPlace: 'Sening oʻrning',
    raceParticipantsLabel: 'Ishtirok etyapti',
    raceNotWagered: 'Bugun istalgan oʻyinni oʻyna — va sen poygadasan',

    raffleTitle: 'Haftalik lotereya',
    raffleEmpty: 'Bu hafta lotereya yoʻq',
    raffleMyInvestedLabel: 'Qoʻyilgan',
    raffleParticipantsLabel: 'Ishtirok etyapti',
    raffleParticipantOne: 'ishtirokchi',
    raffleParticipantFew: 'ishtirokchi',
    raffleParticipantMany: 'ishtirokchi',
    raffleInvestButton: 'Qoʻyish',
    raffleGoToQuestsButton: 'Topshiriqlarga',
    raffleEndedButton: 'Tur tugadi',
    raffleWinnersLink: 'Gʻoliblar',

    investSheetTitle: 'Lotereyaga qoʻyish',
    investSheetLockedBody: "Haftalik lotereyaga qoʻyish uchun SHOT BANDʼga qoʻshil.",
    investSheetJoinButton: 'Qoʻshilish',
    investSheetEndedBody: 'Bu tur allaqachon tugadi — keyingisini kut.',
    investSheetNoBalanceBody: 'Hozircha qoʻyadigan narsa yoʻq — kunlik topshiriqlarni bajarib ol.',
    investSheetDecrease: 'Kamaytirish',
    investSheetIncrease: 'Oshirish',
    investSheetBalanceHint: 'Mavjud: {{balance}}',
    investSheetDisclaimer: 'Qoʻyilganlar qaytarilmaydi — istalgan payt yana qoʻshishing mumkin.',
    investSheetErrorGeneric: 'Qoʻyib boʻlmadi. Qayta urinib koʻr.',
    investSheetSubmitButton: 'Qoʻyish',
  },
  fa: {
    title: 'SHOT BAND',
    loading: 'در حال بارگذاری SHOT BAND...',

    heroWelcome: 'خوش آمدی به',
    heroMemberBadge: 'عضو SHOT BAND',
    heroDaysLeftOne: '{{count}} روز مانده',
    heroDaysLeftFew: '{{count}} روز مانده',
    heroDaysLeftMany: '{{count}} روز مانده',
    heroDaysLeftZero: 'عضویت امروز تمام می‌شود',
    heroRenewButton: 'تمدید',
    heroOfferTitlePrefix: '',
    heroOfferTitleSuffix: 'شارژ کن تا باشگاه روشن شود — همین‌جا یا در هر شارژی.',
    heroOfferBody: 'کش‌بک تا 4% — با سطحت بالا می‌رود — مأموریت روزانه و شانس قرعه‌کشی چاقو.',
    heroOfferFinePrint: 'کل مبلغ روی موجودی بازیت می‌نشیند. هرطور خواستی خرجش کن: کیس، قرارداد، بازی و ارتقا.',
    heroJoinButton: 'عضو شو با',
    heroHowItWorks: 'چطور کار می‌کند',

    rulesTitle: 'SHOT BAND چطور کار می‌کند',
    rule1Prefix: '',
    rule1Suffix: ' را یک‌جا شارژ کن — 28 روز عضو SHOT BAND هستی. سکه‌ها مثل همیشه به موجودیت می‌آیند.',
    rule1Title: 'عضویت در SHOT BAND',
    rule2Title: 'کش‌بک تا 4%',
    rule2:
      'هر بازی سکه‌ای کش‌بک می‌دهد، به شکل جرقه. نرخش با سطحت بالا می‌رود — 1% در سطح 10، 4% در سطح 100. هر 7 روز بگیرش.',
    rule3Title: 'کیس با جرقه',
    rule3Prefix: '',
    rule3Suffix: ' کیس‌های SHOT BAND را باز می‌کند — اسکین تا خود چاقو.',
    rule4Title: 'مأموریت و زنجیره',
    rule4Prefix: 'مأموریت‌های روزانه ',
    rule4Mid: ' می‌دهند. زنجیره 7 روزه را نگه دار — +10 ',
    rule4Suffix: ' بونوس بگیر.',
    rule5Title: 'قرعه‌کشی هفتگی چاقو',
    rule5Prefix: 'هر هفته یک چاقو قرعه‌کشی می‌کنیم. ',
    rule5Suffix: ' خودت را سرمایه‌گذاری کن — بلیت بیشتر، شانس بیشتر.',
    rule6Title: 'رقابت روزانه',
    rule6: 'تا نیمه‌شب (به وقت مسکو) بیشترین سکه را بازی کن و اسکین آن روز را ببر. هر روز، جایزه‌ای تازه.',
    rule7Title: 'کیس رایگان برای گردش',
    rule7:
      'گردش روزانه‌ات کیس‌های قفسه را رایگان باز می‌کند — هرچه بیشتر بازی کنی، کیس رایگان بهتری می‌گیری. تا سقف همه کیس‌ها، هر روز.',

    ticketSheetTitleJoin: 'عضویت در SHOT BAND',
    ticketSheetTitleRenew: 'تمدید SHOT BAND',
    ticketSheetTopupNotePrefix: 'همان لحظه',
    ticketSheetTopupNoteSuffix: 'به موجودیت می‌نشیند — باشگاه هدیه است.',
    ticketSheetRenewDisclaimer: 'تمدید 28 روز به مدت عضویت فعلیت اضافه می‌کند.',
    ticketSheetRenewTooEarly: 'تمدید یک روز پیش از پایان عضویت باز می‌شود — نزدیک آن تاریخ برگرد.',
    ticketSheetBuyButton: 'پرداخت',
    ticketSheetLoadingProviders: 'در حال بارگذاری روش‌های پرداخت...',
    ticketSheetNoProviders: 'الان روش پرداختی در دسترس نیست.',
    ticketSheetErrorTitle: 'فاکتور ساخته نشد',
    ticketSheetErrorHint: 'دوباره تلاش کن یا روش دیگری انتخاب کن',
    ticketSheetLoadErrorGeneric: 'روش‌های پرداخت بارگذاری نشدند.',
    ticketSheetPriceUnavailable: 'برای این روش پرداخت قیمتی نیست — یکی دیگر امتحان کن.',
    ticketSheetCardConfirmTitle: 'تأیید پرداخت',
    ticketSheetCardConfirmMessage: 'برای عضویت در SHOT BAND، {{amount}} از {{card}} کسر شود؟',
    ticketSheetCardConfirmOk: 'پرداخت',
    ticketSheetCardPending: 'Click هنوز پرداخت را تأیید می‌کند — عضویتت خودکار روشن می‌شود.',
    ticketSheetCardErrorTitle: 'پرداخت انجام نشد',
    ticketSheetCardErrorHint: 'دوباره تلاش کن؛ اگر پول از کارتت کم شد با پشتیبانی تماس بگیر',

    cashbackBalanceLabel: 'موجودی باشگاه',
    cashbackCoinsLabel: 'جرقه',
    cashbackTicketsLabel: 'بلیت',
    cashbackNextPayoutLabel: 'پرداخت بعدی:',
    mechanicNameCase: 'کیس‌ها',
    mechanicNameBattle: 'نبردها',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'رولت',
    mechanicNameUpgrade: 'ارتقاها',
    mechanicNameContract: 'قراردادها',
    cashbackChipPrefix: 'کش‌بک',
    cashbackChipLocked: 'کش‌بک از سطح {{level}}',
    cashbackSpendButton: 'خرج کن',
    cashbackInvestButton: 'سرمایه‌گذاری',
    cashbackFrozenNote: 'عضویتت تمام شد — جرقه‌ها و بلیت‌هایت مال خودت می‌مانند. جرقه‌ها را همچنان می‌توانی بگیری، اما خرج‌کردنشان و گذاشتن بلیت فقط داخل باشگاه ممکن است.',
    cashbackUnlockButton: 'بازگشت',
    cashbackClaimReadyLabel: 'کش‌بک آماده است:',
    cashbackClaimButton: 'بگیر',
    cashbackTimerLabel: 'تا',

    streakDayLabel: 'روز {{day}} از 7',
    streakHint: '{{days}} روز پشت سر هم — بونوس',

    freeCasesTitle: 'کیس رایگان',
    freeCasesTurnoverLabel: 'گردش امروز',
    freeCasesNextHintPrefix: '',
    freeCasesNextHintSuffix: 'دیگر بازی کن تا رایگان بازش کنی',
    freeCasesReadyHint: 'رایگان است — بازش کن!',
    freeCasesAllClaimed: 'همه بازکردن‌های رایگان امروز خرج شد — بعد از ریست تازه می‌شوند',
    freeCasesTimerBurnOpen: 'بازکردن رایگان با ریست می‌سوزد',
    freeCasesTimerBurnProgress: 'پیشرفت گردش با ریست می‌سوزد',
    freeCasesTimerPlain: 'ریست روز تا',
    freeCasesTimerNew: 'بازکردن‌های رایگان تازه تا',
    freeCasesOpenFreeButton: 'باز کن',
    freeCasesRulesTitle: 'قوانین کیس رایگان',
    freeCasesRulesWagerTitle: 'با سکه بازی کن',
    freeCasesRulesWagerBody:
      'هر بازی سکه‌ای در گردش روزانه‌ات حساب می‌شود — کیس، نبرد، ارتقا، قرارداد، Rush Mid، رولت.',
    freeCasesRulesOpenTitle: 'به آستانه برس — رایگان باز کن',
    freeCasesRulesOpenBody:
      'هر کیس آستانه گردش خودش را دارد. بهش برسی، باشگاه هزینه بازکردن را می‌دهد. هر کیس، روزی یک بازکردن رایگان.',
    freeCasesRulesResetTitle: 'نیمه‌شب همه‌چیز می‌سوزد',
    freeCasesRulesResetBody:
      'نیمه‌شب (به وقت مسکو) روز ریست می‌شود: پیشرفت گردش و بازکردن‌های رایگان نگرفته می‌سوزند. روز بعد از صفر.',

    questsTitle: 'مأموریت‌های روزانه',
    questsResetLabel: 'مأموریت‌های تازه تا',
    questClaimButton: 'بگیر',
    questsLockedJoinButton: 'عضو شو',
    questGenericTitle: 'مأموریت روزانه',
    questCompletedToastOverline: 'مأموریت انجام شد!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: '3 کیس',
    quest_open_3_cases_2500_suffix: 'به بالا باز کن',
    quest_open_3_cases_2500_unit: 'کیس',
    quest_rush_3_matches_prefix: '3 مسابقه Rush Mid بازی کن',
    quest_rush_3_matches_unit: 'مسابقه',
    quest_open_band_case_prefix: 'یک کیس SHOT BAND باز کن',
    quest_open_band_case_unit: 'کیس',
    quest_wager_25k_prefix: '',
    quest_wager_25k_suffix: 'بازی کن',
    quest_battles_2_5k_prefix: '2 نبرد کیس با ورودی',
    quest_battles_2_5k_suffix: 'به بالا بازی کن',
    quest_battles_2_5k_unit: 'نبرد',
    quest_upgrades_3_2500_prefix: '3 ارتقا به ارزش',
    quest_upgrades_3_2500_suffix: 'به بالا بزن',
    quest_upgrades_3_2500_unit: 'ارتقا',
    quest_contract_10k_prefix: 'یک قرارداد به ارزش',
    quest_contract_10k_suffix: 'به بالا ببند',
    quest_contract_10k_unit: 'قرارداد',
    quest_win_battle_prefix: 'یک نبرد کیس ببر',
    quest_win_battle_unit: 'نبرد',
    quest_win_upgrade_prefix: 'یک ارتقا ببر',
    quest_win_upgrade_unit: 'ارتقا',
    quest_open_case_12500_prefix: 'یک کیس به ارزش',
    quest_open_case_12500_suffix: 'به بالا باز کن',
    quest_open_case_12500_unit: 'کیس',
    quest_open_5_cases_1000_prefix: '5 کیس',
    quest_open_5_cases_1000_suffix: 'به بالا باز کن',
    quest_open_5_cases_1000_unit: 'کیس',
    quest_roulette_play_prefix: 'یک دور رولت بازی کن',
    quest_roulette_play_unit: 'دور',
    quest_contracts_25k_sum_prefix: 'روی‌هم قرارداد به ارزش',
    quest_contracts_25k_sum_suffix: 'ببند',
    quest_upgrades_15k_sum_prefix: 'روی‌هم ارتقا به ارزش',
    quest_upgrades_15k_sum_suffix: 'بزن',
    quest_rush_5_matches_prefix: '5 مسابقه Rush Mid بازی کن',
    quest_rush_5_matches_unit: 'مسابقه',
    quest_wager_50k_prefix: '',
    quest_wager_50k_suffix: 'بازی کن',
    quest_wager_10k_battles_prefix: '',
    quest_wager_10k_battles_suffix: 'در نبرد کیس بازی کن',
    quest_wager_10k_rush_prefix: '',
    quest_wager_10k_rush_suffix: 'در Rush Mid بازی کن',
    quest_wager_10k_roulette_prefix: '',
    quest_wager_10k_roulette_suffix: 'در رولت بازی کن',
    quest_wager_100k_prefix: '',
    quest_wager_100k_suffix: 'بازی کن',
    quest_rush_mid_win_prefix: 'یک مسابقه Rush Mid ببر',
    quest_rush_mid_win_unit: 'برد',
    quest_big_drop_25k_prefix: 'از یک کیس آیتمی گران‌تر از',
    quest_big_drop_25k_suffix: 'در بیاور',
    quest_big_drop_25k_unit: 'آیتم',
    quest_risky_upgrade_35_prefix: 'یک ارتقا با شانس 35% یا کمتر ببر',
    quest_risky_upgrade_35_unit: 'ارتقا',
    quest_covert_drop_prefix: 'از یک کیس آیتم Covert در بیاور',
    quest_covert_drop_unit: 'آیتم',

    raceTitle: 'رقابت روزانه',
    raceEmpty: 'امروز رقابتی نیست — بعداً سر بزن',
    rulesLinkLabel: 'قوانین',
    raceRulesTitle: 'قوانین رقابت روزانه',
    raceRulesPlayTitle: 'چطور ببریم',
    raceRulesPlayBody:
      'هر چیزی در SHOT بازی کن — کیس، ارتقا، قرارداد، نبرد، Rush Mid، رولت. سکه‌ای که خرج بازی می‌کنی حساب می‌شود: بیشترین گردش روزانه می‌برد.',
    raceRulesPrizeTitle: 'جایزه',
    raceRulesPrizeBody:
      'هر روز یک اسکین تازه. نیمه‌شب (به وقت مسکو) به نفر اول می‌رسد و مستقیم در انبارش می‌افتد.',
    raceRulesMembersTitle: 'فقط اعضا',
    raceRulesMembersBody: 'رقابت برای اعضای SHOT BAND است. بازیت خودکار حساب می‌شود — چیزی لازم نیست فعال کنی.',
    raffleRulesTitle: 'قوانین قرعه‌کشی هفتگی',
    raffleRulesTicketsTitle: 'بلیت جمع کن',
    raffleRulesTicketsBodyPrefix: 'مأموریت‌های روزانه را انجام بده تا بلیت قرعه‌کشی بگیری',
    raffleRulesTicketsBodySuffix: '',
    raffleRulesChanceTitle: 'سرمایه‌گذاری کن تا شانست بالا برود',
    raffleRulesChanceBody:
      'بلیت‌ها را در دور سرمایه‌گذاری کن — هرچه بیشتر بگذاری، شانست بیشتر است. بلیت سرمایه‌گذاری‌شده برنمی‌گردد، اما همیشه می‌توانی بیشتر بگذاری.',
    raffleRulesFinalTitle: 'فینال',
    raffleRulesFinalBody: 'هر دور یک هفته است. برنده تصادفی انتخاب می‌شود و اسکین مستقیم در انبارش می‌افتد.',
    racePrizeLabel: 'جایزه امروز',
    raceYourPlace: 'جایگاه تو',
    raceParticipantsLabel: 'در حال بازی',
    raceNotWagered: 'امروز هر چیزی بازی کن تا وارد رقابت شوی',

    raffleTitle: 'قرعه‌کشی هفتگی',
    raffleEmpty: 'این هفته قرعه‌کشی در جریان نیست',
    raffleMyInvestedLabel: 'سرمایه‌گذاری تو',
    raffleParticipantsLabel: 'در حال بازی',
    raffleParticipantOne: 'شرکت‌کننده',
    raffleParticipantFew: 'شرکت‌کننده',
    raffleParticipantMany: 'شرکت‌کننده',
    raffleInvestButton: 'سرمایه‌گذاری',
    raffleGoToQuestsButton: 'رفتن به مأموریت‌ها',
    raffleEndedButton: 'دور تمام شد',
    raffleWinnersLink: 'برندگان',

    investSheetTitle: 'سرمایه‌گذاری در قرعه‌کشی',
    investSheetLockedBody: 'برای سرمایه‌گذاری در قرعه‌کشی هفتگی به SHOT BAND بپیوند.',
    investSheetJoinButton: 'عضو شو',
    investSheetEndedBody: 'این دور تمام شد — منتظر دور بعدی بمان.',
    investSheetNoBalanceBody: 'هنوز چیزی برای سرمایه‌گذاری نداری — مأموریت‌های روزانه را انجام بده.',
    investSheetDecrease: 'کم کن',
    investSheetIncrease: 'زیاد کن',
    investSheetBalanceHint: '{{balance}} در دسترس',
    investSheetDisclaimer: 'مبلغ سرمایه‌گذاری‌شده برنمی‌گردد — همیشه می‌توانی بیشتر بگذاری.',
    investSheetErrorGeneric: 'سرمایه‌گذاری نشد. دوباره تلاش کن.',
    investSheetSubmitButton: 'سرمایه‌گذاری',
  },
  pt: {
    title: 'SHOT BAND',
    loading: 'Carregando SHOT BAND...',

    heroWelcome: 'Bem-vindo ao',
    heroMemberBadge: 'Você está no SHOT BAND',
    heroDaysLeftOne: 'Falta {{count}} dia',
    heroDaysLeftFew: 'Faltam {{count}} dias',
    heroDaysLeftMany: 'Faltam {{count}} dias',
    heroDaysLeftZero: 'A assinatura termina hoje',
    heroRenewButton: 'Renovar',
    heroOfferTitlePrefix: 'Um depósito de',
    heroOfferTitleSuffix: 'ativa o clube — aqui ou em qualquer depósito.',
    heroOfferBody: 'Cashback de até 4% — cresce com o nível —, missões diárias e uma chance de ganhar uma faca no sorteio.',
    heroOfferFinePrint: 'O valor inteiro cai no seu saldo de jogo. Gaste em caixas, contratos, jogos e upgrades como quiser.',
    heroJoinButton: 'Entrar por',
    heroHowItWorks: 'Como funciona',

    rulesTitle: 'Como funciona o SHOT BAND',
    rule1Prefix: 'Deposite ',
    rule1Suffix: ' em um único pagamento — você entra no SHOT BAND por 28 dias. As moedas caem no seu saldo como sempre.',
    rule1Title: 'Entrada no SHOT BAND',
    rule2Title: 'Cashback de até 4%',
    rule2: 'Todo jogo com moedas devolve cashback em faíscas. A taxa cresce com o nível — 1% no nível 10, 4% no nível 100. Resgate a cada 7 dias.',
    rule3Title: 'Caixas por faíscas',
    rule3Prefix: 'As faíscas ',
    rule3Suffix: ' abrem caixas SHOT BAND — skins que vão até facas.',
    rule4Title: 'Missões e sequência',
    rule4Prefix: 'As missões diárias rendem ',
    rule4Mid: '. Mantenha uma sequência de 7 dias — ganhe +10 ',
    rule4Suffix: ' de bônus.',
    rule5Title: 'Sorteio semanal de faca',
    rule5Prefix: 'Toda semana sorteamos uma faca. Invista seus ',
    rule5Suffix: ' — quanto mais bilhetes, maior a chance.',
    rule6Title: 'Corrida do dia',
    rule6: 'Jogue mais moedas que todo mundo até a meia-noite (MSK) — e a skin do dia é sua. Todo dia um prêmio novo.',
    rule7Title: 'Caixas grátis por volume',
    rule7: 'O volume jogado no dia abre as caixas da prateleira de graça — quanto mais você joga, mais cara a caixa grátis. Pode ser todas as caixas, todos os dias.',

    ticketSheetTitleJoin: 'Entrar no SHOT BAND',
    ticketSheetTitleRenew: 'Renovar o SHOT BAND',
    ticketSheetTopupNotePrefix: 'Seu saldo recebe',
    ticketSheetTopupNoteSuffix: 'na hora — o clube vem de presente.',
    ticketSheetRenewDisclaimer: 'A renovação soma 28 dias ao prazo atual da assinatura.',
    ticketSheetRenewTooEarly: 'A renovação abre um dia antes do fim da assinatura — volte perto dessa data.',
    ticketSheetBuyButton: 'Pagar',
    ticketSheetLoadingProviders: 'Carregando formas de pagamento...',
    ticketSheetNoProviders: 'Nenhuma forma de pagamento disponível no momento.',
    ticketSheetErrorTitle: 'Não foi possível criar a fatura',
    ticketSheetErrorHint: 'Tente de novo ou escolha outra forma',
    ticketSheetLoadErrorGeneric: 'Não foi possível carregar as formas de pagamento.',
    ticketSheetPriceUnavailable: 'Preço indisponível para esta forma de pagamento — escolha outra.',
    ticketSheetCardConfirmTitle: 'Confirme o pagamento',
    ticketSheetCardConfirmMessage: 'Cobrar {{amount}} do cartão {{card}} pelo passe do SHOT BAND?',
    ticketSheetCardConfirmOk: 'Pagar',
    ticketSheetCardPending: 'O Click ainda está confirmando o pagamento — a assinatura será ativada automaticamente.',
    ticketSheetCardErrorTitle: 'O pagamento não passou',
    ticketSheetCardErrorHint: 'Tente de novo; se o dinheiro saiu do cartão, fale com o suporte',

    cashbackBalanceLabel: 'Saldo do clube',
    cashbackCoinsLabel: 'Faíscas',
    cashbackTicketsLabel: 'Bilhetes',
    cashbackNextPayoutLabel: 'Próximo pagamento:',
    mechanicNameCase: 'Caixas',
    mechanicNameBattle: 'Batalhas',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Roleta',
    mechanicNameUpgrade: 'Upgrades',
    mechanicNameContract: 'Contratos',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: 'cashback a partir do nível {{level}}',
    cashbackSpendButton: 'Gastar',
    cashbackInvestButton: 'Investir',
    cashbackFrozenNote: 'A assinatura acabou — as faíscas e os bilhetes continuam seus. Você ainda pode resgatar faíscas; gastar e investir bilhetes só com o clube ativo.',
    cashbackUnlockButton: 'Voltar',
    cashbackClaimReadyLabel: 'Cashback pronto:',
    cashbackClaimButton: 'Resgatar',
    cashbackTimerLabel: 'em',

    streakDayLabel: 'Dia {{day}} de 7',
    streakHint: '{{days}} dias seguidos — bônus',

    freeCasesTitle: 'Caixa grátis',
    freeCasesTurnoverLabel: 'Volume hoje',
    freeCasesNextHintPrefix: 'Mais',
    freeCasesNextHintSuffix: 'de volume — e você abre de graça',
    freeCasesReadyHint: 'Dá para abrir de graça — aproveite!',
    freeCasesAllClaimed: 'Tudo que era grátis hoje já foi aberto — novas aberturas após o reset',
    freeCasesTimerBurnOpen: 'Se não abrir até o reset, perde',
    freeCasesTimerBurnProgress: 'O progresso do volume some em',
    freeCasesTimerPlain: 'O dia reseta em',
    freeCasesTimerNew: 'Novas aberturas grátis em',
    freeCasesOpenFreeButton: 'Abrir',
    freeCasesRulesTitle: 'Regras da caixa grátis',
    freeCasesRulesWagerTitle: 'Jogue com moedas',
    freeCasesRulesWagerBody: 'Todo jogo com moedas entra no volume do dia — caixas, batalhas, upgrades, contratos, Rush Mid, roleta.',
    freeCasesRulesOpenTitle: 'Bateu a meta — abre de graça',
    freeCasesRulesOpenBody: 'Cada caixa tem sua própria meta de volume. Chegou lá — o clube paga a abertura. Uma abertura grátis por caixa por dia.',
    freeCasesRulesResetTitle: 'À meia-noite tudo zera',
    freeCasesRulesResetBody: 'À meia-noite (MSK) o dia reseta: o progresso do volume e as aberturas grátis não usadas somem. Novo dia — do zero.',

    questsTitle: 'Missões do dia',
    questsResetLabel: 'Novas missões em',
    questClaimButton: 'Resgatar',
    questsLockedJoinButton: 'Entrar',
    questGenericTitle: 'Missão diária',
    questCompletedToastOverline: 'Missão concluída!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Abra 3 caixas de',
    quest_open_3_cases_2500_suffix: 'ou mais',
    quest_open_3_cases_2500_unit: 'caixas',
    quest_rush_3_matches_prefix: 'Jogue 3 partidas de Rush Mid',
    quest_rush_3_matches_unit: 'partidas',
    quest_open_band_case_prefix: 'Abra uma caixa SHOT BAND',
    quest_open_band_case_unit: 'caixa',
    quest_wager_25k_prefix: 'Jogue',
    quest_wager_25k_suffix: '',
    quest_battles_2_5k_prefix: 'Jogue 2 batalhas com entrada de',
    quest_battles_2_5k_suffix: 'ou mais',
    quest_battles_2_5k_unit: 'batalhas',
    quest_upgrades_3_2500_prefix: 'Faça 3 upgrades de',
    quest_upgrades_3_2500_suffix: 'ou mais',
    quest_upgrades_3_2500_unit: 'upgrades',
    quest_contract_10k_prefix: 'Feche um contrato de',
    quest_contract_10k_suffix: 'ou mais',
    quest_contract_10k_unit: 'contrato',
    quest_win_battle_prefix: 'Vença uma batalha de caixas',
    quest_win_battle_unit: 'batalha',
    quest_win_upgrade_prefix: 'Vença um upgrade',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Abra uma caixa de',
    quest_open_case_12500_suffix: 'ou mais',
    quest_open_case_12500_unit: 'caixa',
    quest_open_5_cases_1000_prefix: 'Abra 5 caixas de',
    quest_open_5_cases_1000_suffix: 'ou mais',
    quest_open_5_cases_1000_unit: 'caixas',
    quest_roulette_play_prefix: 'Jogue uma rodada de roleta',
    quest_roulette_play_unit: 'rodada',
    quest_contracts_25k_sum_prefix: 'Feche contratos somando',
    quest_contracts_25k_sum_suffix: '',
    quest_upgrades_15k_sum_prefix: 'Faça upgrades somando',
    quest_upgrades_15k_sum_suffix: '',
    quest_rush_5_matches_prefix: 'Jogue 5 partidas de Rush Mid',
    quest_rush_5_matches_unit: 'partidas',
    quest_wager_50k_prefix: 'Jogue',
    quest_wager_50k_suffix: '',
    quest_wager_10k_battles_prefix: 'Jogue',
    quest_wager_10k_battles_suffix: 'em batalhas de caixas',
    quest_wager_10k_rush_prefix: 'Jogue',
    quest_wager_10k_rush_suffix: 'no Rush Mid',
    quest_wager_10k_roulette_prefix: 'Jogue',
    quest_wager_10k_roulette_suffix: 'na roleta',
    quest_wager_100k_prefix: 'Jogue',
    quest_wager_100k_suffix: '',
    quest_rush_mid_win_prefix: 'Vença uma partida de Rush Mid',
    quest_rush_mid_win_unit: 'vitória',
    quest_big_drop_25k_prefix: 'Tire um item de mais de',
    quest_big_drop_25k_suffix: 'de uma caixa',
    quest_big_drop_25k_unit: 'item',
    quest_risky_upgrade_35_prefix: 'Vença um upgrade com chance de até 35%',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Tire um item Covert de uma caixa',
    quest_covert_drop_unit: 'item',

    raceTitle: 'Corrida do dia',
    raceEmpty: 'Hoje não tem corrida — volte mais tarde',
    rulesLinkLabel: 'Regras',
    raceRulesTitle: 'Regras da corrida do dia',
    raceRulesPlayTitle: 'Como vencer',
    raceRulesPlayBody: 'Jogue o que quiser no SHOT — caixas, upgrades, contratos, batalhas, Rush Mid, roleta. Contam as moedas gastas nos jogos: quem tiver o maior volume do dia vence.',
    raceRulesPrizeTitle: 'O prêmio',
    raceRulesPrizeBody: 'Todo dia uma skin nova. À meia-noite (MSK) ela vai para o primeiro lugar e cai direto no inventário.',
    raceRulesMembersTitle: 'Só para o clube',
    raceRulesMembersBody: 'A corrida é para membros do SHOT BAND. O jogo conta automaticamente — não precisa ativar nada.',
    raffleRulesTitle: 'Regras do sorteio da semana',
    raffleRulesTicketsTitle: 'Ganhe bilhetes',
    raffleRulesTicketsBodyPrefix: 'Complete as missões do dia — elas dão bilhetes',
    raffleRulesTicketsBodySuffix: 'do sorteio.',
    raffleRulesChanceTitle: 'Invista e aumente a chance',
    raffleRulesChanceBody: 'Invista bilhetes na rodada — quanto mais investir, maior a chance. O que foi investido não volta, mas dá para adicionar mais sempre.',
    raffleRulesFinalTitle: 'A final',
    raffleRulesFinalBody: 'A rodada dura uma semana. O vencedor é sorteado ao acaso e a skin cai direto no inventário.',
    racePrizeLabel: 'Prêmio do dia',
    raceYourPlace: 'Sua posição',
    raceParticipantsLabel: 'Jogando',
    raceNotWagered: 'Jogue qualquer coisa hoje — e você entra na corrida',

    raffleTitle: 'Sorteio da semana',
    raffleEmpty: 'Não há sorteio nesta semana',
    raffleMyInvestedLabel: 'Investido',
    raffleParticipantsLabel: 'Jogando',
    raffleParticipantOne: 'participante',
    raffleParticipantFew: 'participantes',
    raffleParticipantMany: 'participantes',
    raffleInvestButton: 'Investir',
    raffleGoToQuestsButton: 'Ir às missões',
    raffleEndedButton: 'Rodada encerrada',
    raffleWinnersLink: 'Vencedores',

    investSheetTitle: 'Investir no sorteio',
    investSheetLockedBody: 'Entre no SHOT BAND para investir no sorteio semanal.',
    investSheetJoinButton: 'Entrar',
    investSheetEndedBody: 'Esta rodada já terminou — espere a próxima.',
    investSheetNoBalanceBody: 'Ainda não há nada para investir — complete as missões do dia para ganhar.',
    investSheetDecrease: 'Diminuir',
    investSheetIncrease: 'Aumentar',
    investSheetBalanceHint: 'Disponível: {{balance}}',
    investSheetDisclaimer: 'O que foi investido não volta — dá para adicionar mais a qualquer momento.',
    investSheetErrorGeneric: 'Não foi possível investir. Tente de novo.',
    investSheetSubmitButton: 'Investir',
  },
  tr: {
    title: 'SHOT BAND',
    loading: 'SHOT BAND yükleniyor...',

    heroWelcome: 'Hoş geldin',
    heroMemberBadge: "SHOT BAND'desin",
    heroDaysLeftOne: '{{count}} gün kaldı',
    heroDaysLeftFew: '{{count}} gün kaldı',
    heroDaysLeftMany: '{{count}} gün kaldı',
    heroDaysLeftZero: 'Üyelik bugün bitiyor',
    heroRenewButton: 'Uzat',
    heroOfferTitlePrefix: 'Kulüp,',
    heroOfferTitleSuffix: 'yatırınca açılır — burada ya da herhangi bir yatırmada.',
    heroOfferBody: "%4'e kadar cashback — seviyeyle büyür —, günlük görevler ve çekilişte bıçak kazanma şansı.",
    heroOfferFinePrint: "Tutarın tamamı oyun bakiyene düşer. Kasalara, kontratlara, oyunlara ve upgrade'lere istediğin gibi harca.",
    heroJoinButton: 'Katıl:',
    heroHowItWorks: 'Nasıl çalışır',

    rulesTitle: 'SHOT BAND nasıl çalışır',
    rule1Prefix: 'Tek ödemede ',
    rule1Suffix: " yatır — 28 gün boyunca SHOT BAND'desin. Coinler her zamanki gibi bakiyene düşer.",
    rule1Title: "SHOT BAND'e giriş",
    rule2Title: "%4'e kadar cashback",
    rule2: 'Coinle oynanan her oyun kıvılcım olarak cashback verir. Oran seviyeyle büyür — 10. seviyede %1, 100. seviyede %4. Her 7 günde bir al.',
    rule3Title: 'Kıvılcımla kasa',
    rule3Prefix: 'Kıvılcımlar ',
    rule3Suffix: ' SHOT BAND kasalarını açar — içinde bıçağa kadar skinler var.',
    rule4Title: 'Görevler ve seri',
    rule4Prefix: 'Günlük görevler ',
    rule4Mid: ' kazandırır. 7 günlük seriyi koru — bonus olarak +10 ',
    rule4Suffix: ' al.',
    rule5Title: 'Haftalık bıçak çekilişi',
    rule5Prefix: 'Her hafta bir bıçak çekiliyor. Biletlerini ',
    rule5Suffix: ' yatır — ne kadar çok bilet, o kadar yüksek şans.',
    rule6Title: 'Günün yarışı',
    rule6: 'Gece yarısına (MSK) kadar herkesten çok coin oyna — günün skini senin. Her gün yeni ödül.',
    rule7Title: 'Ciroya bedava kasa',
    rule7: 'Günlük ciro raftaki kasaları bedava açar — ne kadar çok oynarsan bedava kasa o kadar pahalı. İstersen tüm kasalar, istersen her gün.',

    ticketSheetTitleJoin: "SHOT BAND'e katıl",
    ticketSheetTitleRenew: "SHOT BAND'i uzat",
    ticketSheetTopupNotePrefix: 'Bakiyene hemen',
    ticketSheetTopupNoteSuffix: 'yatar — kulüp hediye.',
    ticketSheetRenewDisclaimer: 'Uzatma mevcut üyelik süresine eklenir — artı 28 gün.',
    ticketSheetRenewTooEarly: 'Uzatma, üyelik bitmeden bir gün önce açılır — o tarihe yakın tekrar gel.',
    ticketSheetBuyButton: 'Öde',
    ticketSheetLoadingProviders: 'Ödeme yöntemleri yükleniyor...',
    ticketSheetNoProviders: 'Şu anda kullanılabilir ödeme yöntemi yok.',
    ticketSheetErrorTitle: 'Fatura oluşturulamadı',
    ticketSheetErrorHint: 'Tekrar dene ya da başka bir yöntem seç',
    ticketSheetLoadErrorGeneric: 'Ödeme yöntemleri yüklenemedi.',
    ticketSheetPriceUnavailable: 'Bu ödeme yöntemi için fiyat yok — başka birini seç.',
    ticketSheetCardConfirmTitle: 'Ödemeyi onayla',
    ticketSheetCardConfirmMessage: 'SHOT BAND girişi için {{card}} kartından {{amount}} çekilsin mi?',
    ticketSheetCardConfirmOk: 'Öde',
    ticketSheetCardPending: 'Click ödemeyi hâlâ onaylıyor — üyelik otomatik açılacak.',
    ticketSheetCardErrorTitle: 'Ödeme geçmedi',
    ticketSheetCardErrorHint: 'Tekrar dene; para kartından çıktıysa desteğe yaz',

    cashbackBalanceLabel: 'Kulüp bakiyesi',
    cashbackCoinsLabel: 'Kıvılcım',
    cashbackTicketsLabel: 'Biletler',
    cashbackNextPayoutLabel: 'Sonraki ödeme:',
    mechanicNameCase: 'Kasalar',
    mechanicNameBattle: 'Savaşlar',
    mechanicNameRushMid: 'Rush Mid',
    mechanicNameRoulette: 'Rulet',
    mechanicNameUpgrade: 'Upgrade',
    mechanicNameContract: 'Kontratlar',
    cashbackChipPrefix: 'cashback',
    cashbackChipLocked: '{{level}}. seviyeden itibaren cashback',
    cashbackSpendButton: 'Harca',
    cashbackInvestButton: 'Yatır',
    cashbackFrozenNote: 'Üyelik bitti — kıvılcımlar ve biletler senin. Kıvılcımları şimdi de alabilirsin; harcamak ve bilet yatırmak için kulüp açık olmalı.',
    cashbackUnlockButton: 'Geri dön',
    cashbackClaimReadyLabel: 'Cashback hazır:',
    cashbackClaimButton: 'Al',
    cashbackTimerLabel: 'kalan:',

    streakDayLabel: '7 günden {{day}}. gün',
    streakHint: 'Art arda {{days}} gün — bonus',

    freeCasesTitle: 'Bedava kasa',
    freeCasesTurnoverLabel: 'Bugünkü ciro',
    freeCasesNextHintPrefix: 'Bedava açmak için',
    freeCasesNextHintSuffix: 'ciro daha',
    freeCasesReadyHint: 'Bedava açabilirsin — al!',
    freeCasesAllClaimed: 'Bugünün tüm bedava açılışları kullanıldı — yenileri sıfırlamadan sonra',
    freeCasesTimerBurnOpen: 'Sıfırlamaya kadar açmazsan yanar',
    freeCasesTimerBurnProgress: 'Ciro ilerlemesinin yanmasına',
    freeCasesTimerPlain: 'Gün sıfırlanmasına',
    freeCasesTimerNew: 'Yeni bedava açılışlara',
    freeCasesOpenFreeButton: 'Aç',
    freeCasesRulesTitle: 'Bedava kasa kuralları',
    freeCasesRulesWagerTitle: 'Coinle oyna',
    freeCasesRulesWagerBody: 'Coinle oynanan her oyun günlük ciroya girer — kasalar, savaşlar, upgrade, kontratlar, Rush Mid, rulet.',
    freeCasesRulesOpenTitle: 'Eşiği geç — bedava aç',
    freeCasesRulesOpenBody: 'Her kasanın kendi ciro eşiği var. Ulaştın mı — açılışı kulüp öder. Her kasa için günde bir bedava açılış.',
    freeCasesRulesResetTitle: 'Gece yarısı her şey yanar',
    freeCasesRulesResetBody: 'Gece yarısı (MSK) gün sıfırlanır: ciro ilerlemesi ve kullanılmayan bedava açılışlar yanar. Yeni gün — sıfırdan.',

    questsTitle: 'Günün görevleri',
    questsResetLabel: 'Yeni görevlere',
    questClaimButton: 'Al',
    questsLockedJoinButton: 'Katıl',
    questGenericTitle: 'Günlük görev',
    questCompletedToastOverline: 'Görev tamamlandı!',
    questGenericUnit: '',

    quest_open_3_cases_2500_prefix: 'Değeri',
    quest_open_3_cases_2500_suffix: 've üzeri olan 3 kasa aç',
    quest_open_3_cases_2500_unit: 'kasa',
    quest_rush_3_matches_prefix: '3 Rush Mid maçı oyna',
    quest_rush_3_matches_unit: 'maç',
    quest_open_band_case_prefix: 'Bir SHOT BAND kasası aç',
    quest_open_band_case_unit: 'kasa',
    quest_wager_25k_prefix: 'Toplam',
    quest_wager_25k_suffix: 'oyna',
    quest_battles_2_5k_prefix: 'Girişi',
    quest_battles_2_5k_suffix: 've üzeri olan 2 kasa savaşı oyna',
    quest_battles_2_5k_unit: 'savaş',
    quest_upgrades_3_2500_prefix: 'Değeri',
    quest_upgrades_3_2500_suffix: 've üzeri olan 3 upgrade yap',
    quest_upgrades_3_2500_unit: 'upgrade',
    quest_contract_10k_prefix: 'Değeri',
    quest_contract_10k_suffix: 've üzeri olan bir kontrat yap',
    quest_contract_10k_unit: 'kontrat',
    quest_win_battle_prefix: 'Bir kasa savaşı kazan',
    quest_win_battle_unit: 'savaş',
    quest_win_upgrade_prefix: 'Bir upgrade kazan',
    quest_win_upgrade_unit: 'upgrade',
    quest_open_case_12500_prefix: 'Değeri',
    quest_open_case_12500_suffix: 've üzeri olan bir kasa aç',
    quest_open_case_12500_unit: 'kasa',
    quest_open_5_cases_1000_prefix: 'Değeri',
    quest_open_5_cases_1000_suffix: 've üzeri olan 5 kasa aç',
    quest_open_5_cases_1000_unit: 'kasa',
    quest_roulette_play_prefix: 'Bir rulet raundu oyna',
    quest_roulette_play_unit: 'raund',
    quest_contracts_25k_sum_prefix: 'Toplam',
    quest_contracts_25k_sum_suffix: 'değerinde kontrat yap',
    quest_upgrades_15k_sum_prefix: 'Toplam',
    quest_upgrades_15k_sum_suffix: 'değerinde upgrade yap',
    quest_rush_5_matches_prefix: '5 Rush Mid maçı oyna',
    quest_rush_5_matches_unit: 'maç',
    quest_wager_50k_prefix: 'Toplam',
    quest_wager_50k_suffix: 'oyna',
    quest_wager_10k_battles_prefix: 'Kasa savaşlarında',
    quest_wager_10k_battles_suffix: 'oyna',
    quest_wager_10k_rush_prefix: "Rush Mid'de",
    quest_wager_10k_rush_suffix: 'oyna',
    quest_wager_10k_roulette_prefix: 'Rulette',
    quest_wager_10k_roulette_suffix: 'oyna',
    quest_wager_100k_prefix: 'Toplam',
    quest_wager_100k_suffix: 'oyna',
    quest_rush_mid_win_prefix: 'Bir Rush Mid maçı kazan',
    quest_rush_mid_win_unit: 'galibiyet',
    quest_big_drop_25k_prefix: 'Kasadan değeri',
    quest_big_drop_25k_suffix: 'üzeri bir eşya düşür',
    quest_big_drop_25k_unit: 'eşya',
    quest_risky_upgrade_35_prefix: 'Şansı %35 ve altı olan bir upgrade kazan',
    quest_risky_upgrade_35_unit: 'upgrade',
    quest_covert_drop_prefix: 'Kasadan bir Covert eşya düşür',
    quest_covert_drop_unit: 'eşya',

    raceTitle: 'Günün yarışı',
    raceEmpty: 'Bugün yarış yok — daha sonra tekrar bak',
    rulesLinkLabel: 'Kurallar',
    raceRulesTitle: 'Günün yarışı kuralları',
    raceRulesPlayTitle: 'Nasıl kazanılır',
    raceRulesPlayBody: "SHOT'ta ne istersen oyna — kasalar, upgrade, kontratlar, savaşlar, Rush Mid, rulet. Oyunlara harcanan coinler sayılır: günlük cirosu en yüksek olan kazanır.",
    raceRulesPrizeTitle: 'Ödül',
    raceRulesPrizeBody: 'Her gün yeni bir skin. Gece yarısı (MSK) birinciye gider ve doğrudan envanterine düşer.',
    raceRulesMembersTitle: 'Sadece kulübe',
    raceRulesMembersBody: 'Yarış SHOT BAND üyeleri için. Oyunun otomatik sayılır, bir şey açman gerekmez.',
    raffleRulesTitle: 'Haftalık çekiliş kuralları',
    raffleRulesTicketsTitle: 'Bilet kazan',
    raffleRulesTicketsBodyPrefix: 'Günün görevlerini tamamla — karşılığında çekiliş biletleri',
    raffleRulesTicketsBodySuffix: 'verilir.',
    raffleRulesChanceTitle: 'Yatır ve şansını artır',
    raffleRulesChanceBody: 'Biletleri rauna yatır — ne kadar çok yatırırsan şans o kadar yüksek. Yatırılan geri dönmez, üstüne eklemek her zaman serbest.',
    raffleRulesFinalTitle: 'Final',
    raffleRulesFinalBody: 'Raund bir hafta sürer. Kazanan rastgele seçilir, skin doğrudan envantere düşer.',
    racePrizeLabel: 'Günün ödülü',
    raceYourPlace: 'Sıran',
    raceParticipantsLabel: 'Katılan',
    raceNotWagered: 'Bugün herhangi bir oyun oyna — yarıştasın',

    raffleTitle: 'Haftalık çekiliş',
    raffleEmpty: 'Bu hafta çekiliş yok',
    raffleMyInvestedLabel: 'Yatırılan',
    raffleParticipantsLabel: 'Katılan',
    raffleParticipantOne: 'katılımcı',
    raffleParticipantFew: 'katılımcı',
    raffleParticipantMany: 'katılımcı',
    raffleInvestButton: 'Yatır',
    raffleGoToQuestsButton: 'Görevlere git',
    raffleEndedButton: 'Raund bitti',
    raffleWinnersLink: 'Kazananlar',

    investSheetTitle: 'Çekilişe yatır',
    investSheetLockedBody: "Haftalık çekilişe yatırmak için SHOT BAND'e katıl.",
    investSheetJoinButton: 'Katıl',
    investSheetEndedBody: 'Bu raund çoktan bitti — bir sonrakini bekle.',
    investSheetNoBalanceBody: 'Henüz yatıracak bir şey yok — kazanmak için günün görevlerini tamamla.',
    investSheetDecrease: 'Azalt',
    investSheetIncrease: 'Artır',
    investSheetBalanceHint: 'Kullanılabilir: {{balance}}',
    investSheetDisclaimer: 'Yatırılan geri dönmez — istediğin zaman üstüne ekleyebilirsin.',
    investSheetErrorGeneric: 'Yatırılamadı. Tekrar dene.',
    investSheetSubmitButton: 'Yatır',
  },
});
